// @flow
import React, { Component } from 'react';
import { StyleSheet, View } from 'react-native';
import { Text } from 'trpc-react-native-ui';
import theme from '../../theme-config';
import I18n from '../../lib/i18n';
import FormatService from '../../lib/format';

class PhoneNumberLine extends Component<Props> {
  styles = getStyles();

  render() {
    const styles = this.styles;
    return (
      <View style={styles.container}>
        <Text style={styles.phoneNumber}>
          {FormatService.formatPhone(this.props.phoneNumber, this.props.isKeepingNumber)}
        </Text>
        {this.props.isKeepingNumber && (
          <Text style={styles.portability}>{I18n.t('SignUp.ConfirmPlan.portability')}</Text>
        )}
        {this.props.isTemporaryNumber && (
          <Text style={styles.portability}>{I18n.t('SignUp.ConfirmPlan.isTemporaryNumber')}</Text>
        )}
      </View>
    );
  }
}

type Props = {
  phoneNumber: ?string,
  isKeepingNumber?: boolean,
  isTemporaryNumber?: boolean,
};

function getStyles() {
  return StyleSheet.create({
    container: {
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: 'transparent',
    },
    phoneNumber: {
      color: theme.signUpTextColor,
      fontSize: 16,
      fontWeight: '500',
    },
    portability: {
      color: theme.signUpTextColor,
    },
  });
}

export default PhoneNumberLine;
